import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface UiPreferencesState {
  /** Показывать фото блюд в меню. По умолчанию выкл — пока нет качественных фото. */
  menuShowImages: boolean;
  setMenuShowImages: (value: boolean) => void;
}

export const useUiPreferencesStore = create<UiPreferencesState>()(
  persist(
    (set) => ({
      menuShowImages: false,
      setMenuShowImages: (menuShowImages) => set({ menuShowImages }),
    }),
    { name: 'ui-preferences' },
  ),
);
